// extracted by mini-css-extract-plugin
export var hideEditor = "_if-2";
export var infoIcon = "_if-3";
export var label = "_if-1";
export var labelContainer = "_if-0";
export var readonlyText = "_if-4";